import axios from 'axios';
import constants from '../../../constants';

declare module 'axios' {
    export interface AxiosRequestConfig {
        requireAuth?: boolean;
    }
}

export const api = axios.create({
    baseURL: `${constants.AGENIUM_URL}/v${constants.AGENIUM_API_VERSION}/client/${constants.NEXT_PUBLIC_AGENIUM_CLIENT_CODE}/account/${constants.NEXT_PUBLIC_AGENIUM_ACCOUNT_CODE}`,
    headers: {
        'api-version': constants.AGENIUM_API_VERSION,
        'Content-Type': 'application/json',
    },
});

let token: string;

interface AgeniumToken {
    access_token: string;
    scope: string;
    expires_in: number;
    token_type: string;
}

const getToken = async (): Promise<AgeniumToken> => {
    const {data} = await axios.get('/api/agenium/auth/token');
    return data;
};

api.interceptors.request.use(async (config) => {
    if (config.requireAuth && !token) {
        const data = await getToken();
        token = data.access_token;
    }

    config.headers['Authorization'] = `Bearer ${token}`;

    return config;
});
